import { cx } from '../../lib/utils'

interface SpinnerProps {
  className?: string
  label?: string
}

export function Spinner({ className, label = 'Loading' }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={label}
      className={cx(
        'inline-block animate-spin rounded-[50%] border-2 border-gray-300 border-t-primary-500 dark:border-gray-700 dark:border-t-primary-400',
        className ?? 'size-5',
      )}
    />
  )
}

export function FullPageSpinner() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 dark:bg-gray-950">
      <Spinner className="size-8" />
    </div>
  )
}

export function SectionSpinner({ className }: { className?: string }) {
  return (
    <div className={cx('flex items-center justify-center py-16', className)}>
      <Spinner className="size-6" />
    </div>
  )
}

export default Spinner
